export default "__VITE_ASSET__1df96cc4__"